export const EShapeActionValueTransformMoveType = wcardinal.ui.EShapeActionValueTransformMoveType;